import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from 'services/axiosInstance';
import { ITableRequestParams } from 'components/Table/constants';

export const ThunkGetTableData = createAsyncThunk<
  any,
  { resource: string; params: ITableRequestParams }
>('table/getTableData', async ({ resource, params: { start, end, ...rest } }) => {
  return axiosInstance
    .request({
      method: 'GET',
      url: resource,
      params: {
        _start: start,
        _end: end,
        _sort: rest.sort,
        _order: rest.order,
      },
    })
    .then(res => {
      return {
        data: res.data,
        totalCount: res.headers['x-total-count'],
        start,
        end,
      };
    });
});
